import {Badge} from "react-bootstrap";

const DelinquentBadge = () => {
    return <Badge bg='secondary'>Delinquent</Badge>;
}

export default DelinquentBadge;